/** Segmented page tabs — same tab ids / onChange behavior as inline buttons */
export default function PageTabs({ tabs, value, onChange, className = "" }) {
  return (
    <div className={`page-tabs ${className}`} role="tablist">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={value === t.id}
          className={`page-tabs-btn ${value === t.id ? "active" : ""}`}
          onClick={() => onChange?.(t.id)}
        >
          {t.label}
          {t.count != null ? <span className="page-tabs-count">{t.count}</span> : null}
        </button>
      ))}
    </div>
  );
}
